module.exports = __webpack_public_path__ + "img/box.c77bc58c.png";